import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslate } from '@agilepoint/wat-react';
import { IRadioGroupItemProps, RadioButton, Typography, StackPanel, IColorPickerCalloutRenderProps, FlexBox } from '@agilepoint/wat-react-ux';
import { ColorSetWrapper, CustomColorSetWrapper, PredefinedColorsRadioGroupField, StyledColorPickerCalloutField, StyledIcon } from '../styled-components';
import { PredefinedColors } from '../types';

export const StyleType = (props: IRadioGroupItemProps) => {
    const { itemData, isSelected, toggleSelection } = props;
    return (
        <FlexBox flexDirection='column' className='ap-radio-child-items'>
            <RadioButton label={itemData.name} value={itemData.value} title={itemData.name} checked={isSelected} onChange={toggleSelection} />
            {itemData.key === 'predefinedColor' ? <PredefinedColorSet /> : <CustomColorSet />}
        </FlexBox>
    );
};

const PredefinedColorSet = () => {
    const { watch } = useFormContext();
    const options = React.useMemo(() => [
        { name: 'color1', value: PredefinedColors.Blue, key: PredefinedColors.Blue },
        { name: 'color2', value: PredefinedColors.Purple, key: PredefinedColors.Purple },
        { name: 'color3', value: PredefinedColors.Orange, key: PredefinedColors.Orange },
        { name: 'color4', value: PredefinedColors.Green, key: PredefinedColors.Green },
        { name: 'color5', value: PredefinedColors.Red, key: PredefinedColors.Red }
    ], []);

    const onRenderItem = (props: IRadioGroupItemProps) => {
        const { itemData, isSelected, isDisabled, toggleSelection } = props;
        return (
            <ColorSetWrapper
                tabIndex={isDisabled ? -1 : 0}
                $borderColor={itemData.value}
                $isSelected={isSelected}
                $isDisabled={isDisabled}
                onClick={toggleSelection} />
        );
    };

    return (
        <FlexBox flexDirection='column'>
            <PredefinedColorsRadioGroupField
                name="predefinedColor.color"
                groupName='Predefined Color Set'
                options={options}
                gap="10"
                orientation='horizontal'
                disabled={watch('appStyles') !== 'predefinedColor'}
                onRenderItem={onRenderItem} />
            {/* <StackPanel justifyContent="center" width='100%' gap="15" alignment="center"> */}
            {/* <HorizontalLine $width='calc(100% - 15px)' /> */}
            {/* <StyledSeparatorLabel><Localize translate='common.optionalSperatorText'></Localize></StyledSeparatorLabel> */}
            {/* <HorizontalLine /> */}
            {/* </StackPanel> */}
        </FlexBox>
    );
};

const CustomColorSet = () => {
    const { watch } = useFormContext();
    const translate = useTranslate();
    const customColorSetOptions = React.useMemo(() => [
        { name: 'customColor.menuColor', label: translate('modules.myApps.appDetails.mobileAppDetails.menuColor') }
        // { name: 'customColor.buttonColor', label: translate('modules.myApps.appDetails.mobileAppDetails.buttonColor') }
    ], [translate]);

    const renderPicker = (renderProps: IColorPickerCalloutRenderProps) => <StyledIcon iconName={renderProps.color === '#ffffff' ? 'maa-ellipse-default-color.svg' : 'maa-ellipse.svg'} iconSize='20' fill={renderProps.color} onClick={renderProps.toggleCallout} />;

    return (
        <>
            {
                customColorSetOptions.map((option) => (
                    <StackPanel gap="5" orientation='vertical' key={option.name}>
                        {/* <Typography.H6>{option.label}</Typography.H6> */}
                        <CustomColorSetWrapper alignItems="center" >
                            <StyledColorPickerCalloutField
                                name={option.name}
                                $isDisabled={watch('appStyles') !== 'customColor'}
                                onRender={renderPicker} />
                            <Typography.H6>{watch(option.name)}</Typography.H6>
                        </CustomColorSetWrapper>
                    </StackPanel>
                ))
            }
        </>
    );
};
